import React from "react";
import PropTypes from "prop-types";
import { CardBox, SplitPanel, DescriptionText } from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import {
  CenteredCardContent,
  MissionCreatedTitle
} from "./MissionCreatedStyled";
import IconSelector from "./IconSelector";
import iconsList from "./iconsList";

export const missionCreatedAction = "mission-created_card-displayed";
export const missionCreatedDescription = "history_mission_created-text_1";

export const MissionCreated = ({ jobTitle }) => {
  const t = useTranslate();
  return (
    <CardBox>
      <SplitPanel>
        <CenteredCardContent>
          <IconSelector iconName={iconsList.tool} />
          <MissionCreatedTitle>{jobTitle}</MissionCreatedTitle>
          <DescriptionText>{t(missionCreatedDescription)}</DescriptionText>
        </CenteredCardContent>
      </SplitPanel>
    </CardBox>
  );
};

MissionCreated.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  jobTitle: PropTypes.string
};

export default MissionCreated;
